module.exports = __webpack_public_path__ + "img/tss-12.3ed85bfa.jpg";